import { FeaturedPlayListRounded } from "@material-ui/icons";
import ApplicationResource from "../../utils/resources.enum";
import { QuizAssessmentQuestionBankCreate } from "./quiz-assessment-question-bank.create";
import { QuizAssessmentQuestionBankEdit } from "./quiz-assessment-question-bank.edit";
import { QuizAssessmentQuestionBankList } from "./quiz-assessment-question-bank.list";
import {Route} from "react-router-dom";
import {ImportQuestionBankPage} from "./page/import-question-bank.page";

export const quizAssessmentQuestionBankResource = {
    name: ApplicationResource.QUIZ_ASSESSMENT_QUESTION_BANK,
    icon: FeaturedPlayListRounded,
    options: { label: "Banco de Questões" },
    link: "/quiz-assessment-question-bank",
    tableName: 'quiz-assessment-question-bank',
    list: QuizAssessmentQuestionBankList,
    edit: QuizAssessmentQuestionBankEdit,
    create: QuizAssessmentQuestionBankCreate,
    products: ['quiz'],
    routes: [
        <Route exact path={'/import-assessment-question'} component={ImportQuestionBankPage} />,
    ]
}